export const getTrackerWrapperTransports = (engine) => {

  return [
    {
      engine: engine,
      initProps: {
        gtmId: 'GTM-WQ3C4SFK',
        dataLayer: {},
      },
    },
  ]
}